import React, {useState} from 'react';
import Banner from "../../../../../assets/images/BreachRisk_Manage_Portfolio_Banner.svg";
import BRPPortfolioEntitiesTable
    from "../../../../../components/customBreachBits/BRPortfolio/BRPPortfolioEntitiesTable";
import TileBreachRiskPortfolioManagementEntitiesRemainingPieChart
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskPortfolioManagementEntitiesRemainingPieChart";
import BRBusinessSharingTable
    from "../../../../../components/customBreachBits/BreachRiskSharing/BRBusinessSharingTable";
import {useSelector} from "react-redux";
import {HashLink as Link} from "react-router-hash-link";
import TileBreachRiskPortfolioNumEntitiesSimple
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskPortfolioNumEntitiesSimple";
import BRPSubportfoliosManagementTable
    from "../../../../../components/customBreachBits/BRPortfolio/BRPSubportfoliosManagementTable";
import {mapObject} from "../../../../../util/bbHelpers";
import BBIconIsGroupCollection from "../../../../../assets/bbCustomIcons/BBIconIsGroupCollection";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import EarlyAccessWrapper from "../../../../../components/customBreachBits/settings/EarlyAccessWrapper";
import Skeleton from "react-loading-skeleton";
import {Col, Row} from "reactstrap";

const Dashboard= (props) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    // const {portfolios, selfEntityId, entityInView} = useSelector(({breachrisk})=> breachrisk);

    const customer = customers ? customers[customerInView] : null;
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const customerName = customer ? customer.CustomerName : null;
    const {portfolios, loadingPortfolios, loadingPortfoliosError} = useSelector(({breachrisk}) => breachrisk);

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    // console.log("MANAGE PORTFOLIO PAGE");

    const subportfolios = portfolios && portfolios[customerIdToUse] && portfolios[customerIdToUse].portfolios ? portfolios[customerIdToUse].portfolios : null;
    console.log("Manage Portfolio Page. Here are the subportfolios:", subportfolios);
    const arrayOfSubportfolios = customers
        && subportfolios
        ? Object.values(subportfolios).sort(function(a, b) {
            const textA = a.name.toUpperCase();
            const textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })
        : null;
    const numSubportfolios = arrayOfSubportfolios && Array.isArray(arrayOfSubportfolios) && arrayOfSubportfolios.length;

    const portfolioGroupsSection = <>
        {arrayOfSubportfolios && arrayOfSubportfolios.map((subportfolio, key) => {

            // if(subportfolio.entities && Array.isArray(subportfolio.entities) && subportfolio.entities.length > 0) {
                return <div className="row" key={`${key}_portfolioGroupsSection`}>
                    <div className="col-12">
                        <BRPPortfolioEntitiesTable
                            showManagementOptions
                            showAnalyticsView
                            showInsightsDetails
                            // showSlimView
                            // showCustomerProcessSteps
                            // showAnalyticsWidget
                            tableTitleText={`${subportfolio.name}`}
                            tableDescription={subportfolio.description && `Group description: ${subportfolio.description}`}
                            tableTitleIcon={<Tooltip
                                title={"This is a portfolio group"}><span><BBIconIsGroupCollection/></span></Tooltip>}
                            // tableTipText={"Manage the companies in your portfolio by adding or deleting. Ask for access to reports from companies currently in you portfolio."}
                            showOnlyEntitiesFromTheseSubportfolios={[subportfolio]}
                            primarySubportfolioInView={subportfolio}
                        />
                    </div>
                </div>
            // } else {
            //     //don't include subportfolios with no entities
            //     return null;
            // }
            })

        }


    </>

    // console.log("Preparing portfolioGroupsSection", arrayOfSubportfolios, arrayOfSubportfolios, portfolioGroupsSection);

    return (
        // <MultiBoardWrapper customer={customer}>
        <div className="app-wrapper">
      <div className="animated fadeIn animation-duration-7">
          <div className="row">
              <div className={"col-8 align-self-center"}>
                  <div className={"mx-0 px-0"}>
                      <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                      {/*<h2>Manage Your Portfolio</h2>*/}

                      <h3>{customerName ? customerName : ""}</h3>

                  </div>
              </div>

              <div className={"col-4 align-self-center"}>
                  <h3>BreachRisk™ Cyber Business Intelligence
                  <br/><small>Insights to Improve Your Bottom Line</small></h3>
                  <p>Continuous insights on companies in your portfolio keeps you ahead of the pack. Improve predictions by inviting companies to share their <Link smooth to={{pathname: "/board/BreachRisk/Portfolio/Details/Reports"}}>BreachRisk™ Report</Link>,
                  encouraging them to make attestations, and enabling penetration testing.</p>

              </div>
          </div>

          <hr/>
          <br/>
          {/*<div className={"row"}>*/}
          {/*    <div className={"col-2"}>*/}

          {/*    </div>*/}
          {/*    <div className={"col-8"}>*/}
          {/*        /!*<TileBreachRiskPortfolioManagementEntitiesRemainingPieChart useTwoNumberGrayColors/>*!/*/}
          {/*        <TileBreachRiskPortfolioNumEntitiesSimple/>*/}
          {/*    </div>*/}

          {/*    <div className={"col-2"}>*/}

          {/*    </div>*/}
          {/*</div>*/}
          <div className="row" id={"tourAllCompaniesHeading"}>
              <div className="col-12" id={"tourPortfolioAllCompaniesCol"}>
                  <BRPPortfolioEntitiesTable
                      showManagementOptions
                      showCustomerProcessSteps
                      tableTitleText={"All Companies"}
                      tableTipText={"Manage the companies in your portfolio by adding or deleting. Ask for access to reports from companies currently in you portfolio."}
                      tableDescription={"This is your master portfolio. Add and remove companies to your portfolio, and add companies to groups from here."}
                      // showOnlyEntitiesFromTheseSubportfolios={["0335d425-40fe-4399-a80e-dea58413648a"]}

                  />
              </div>
          </div>
          {/*<EarlyAccessWrapper hideVisibleWrapper>*/}
          <hr/>
          <br/>
          {/*</EarlyAccessWrapper>*/}
          {/*<EarlyAccessWrapper>*/}
              <Row id={"tourPortfolioGroupsHeader"}>
                  <Col>
                      <h1>Portfolio Groups</h1>
                  </Col>
              </Row>
                  {numSubportfolios
                      ? <>
                        {portfolioGroupsSection}

                            </>
                      : !portfolios || loadingPortfolios[customerInView] ? <Skeleton /> : <p><em>You don't have any portfolio groups yet. Use the Portfolio Group Management table to add groups.</em></p>
                  }
          {/*</EarlyAccessWrapper>*/}

          {/*<EarlyAccessWrapper >*/}
          <Row id={"SharingAndGroupManagementHeader"}>
              <Col>
                  <h1>Manage Sharing and Portfolio Groups</h1>
              </Col>
          </Row>
          <hr/>
              <div className="row"  id={""}>
                  <div className="col-12" id={"BRPSubportfoliosManagementTableSection"}>
                      <BRPSubportfoliosManagementTable
                          showManagementOptions
                          // tableTitleText={"Add/Remove Companies"}
                          // tableTipText={"Manage the companies in your portfolio by adding or deleting. Ask for access to reports from companies currently in you portfolio."}
                      />
                  </div>
              </div>
          {/*</EarlyAccessWrapper>*/}


          <hr/>
          {/*<h1>Data Sharing</h1>*/}
          <div className="row" id={"tourBusinessSharingTable"}>
              <div className="col-12">
                  {/*<Accordion expanded={expanded === "Report Sharing"}*/}
                  {/*           onChange={handleChange("Report Sharing")}*/}
                  {/*           elevation={1}*/}
                  {/*           >*/}
                  {/*    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>*/}
                  {/*        <h1 style={{ width: '33%', flexShrink: 0 }}>*/}
                  {/*            Companies Sharing BreachRisk™ Report With You*/}
                  {/*        </h1>*/}
                  {/*        <Typography style={{ color: 'grey',  }}>*/}
                  {/*            A company's approval of a report request continues until they revoke it, even if you remove them from your portfolio.*/}
                  {/*            These are all active requests, though they may not be in your portfolio or may not be approved yet.*/}
                  {/*        </Typography>*/}
                  {/*    </AccordionSummary>*/}
                  {/*    <AccordionDetails>*/}
                  {/*        <div className="app-wrapper">*/}
                              <BRBusinessSharingTable
                                  constTitleOverrideText={"BreachRisk™ Detail Sharing Requests"}
                                  tableTipText={"These are all active sharing requests, though they may not be in your portfolio or may not be approved yet."}
                                  showBRPView
                              />
                          {/*</div>*/}
                  {/*    </AccordionDetails>*/}
                  {/*</Accordion>*/}
              </div>
          </div>


      </div>
        </div>
        // </MultiBoardWrapper>
    )
}
export default Dashboard;